export enum PortalLayout {
    BLANK,
    LARAVEL,
    SPA,
}
